import { render, staticRenderFns } from "./BroadcastHistory.vue?vue&type=template&id=2e464a08&scoped=true&"
import script from "./BroadcastHistory.vue?vue&type=script&lang=ts&"
export * from "./BroadcastHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastHistory.vue?vue&type=style&index=0&id=2e464a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e464a08",
  null
  
)

export default component.exports